import React from "react";
import moment from "moment";
import { Badge } from "@mantine/core";

interface IPassportInfoProps {
    passportNumber: string | null;
    passportIssueDate: string | null;
    passportExpiryDate: string | null;
}

const PassportInfo: React.FC<IPassportInfoProps> = ({
    passportNumber,
    passportIssueDate,
    passportExpiryDate,
}) => {
    // Check if any passport information is available
    const hasPassportInfo = passportNumber || passportIssueDate || passportExpiryDate;

    if (!hasPassportInfo) {
        return (
            <div className="text-sm text-gray-400 italic">
                Not provided
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-1.5">
            {passportNumber && (
                <div className="flex items-center gap-2">
                    <Badge size="xs" variant="light" color="blue">
                        Passport
                    </Badge>
                    <span className="text-sm font-mono font-medium">
                        {passportNumber}
                    </span>
                </div>
            )}

            {(passportIssueDate || passportExpiryDate) && (
                <div className="text-xs text-gray-600 ml-1">
                    {passportIssueDate && (
                        <div className="flex items-center gap-1">
                            <span className="text-gray-500">Issued:</span>
                            <span className="font-medium">
                                {moment(passportIssueDate).format("DD MMM YYYY")}
                            </span>
                        </div>
                    )}
                    {passportExpiryDate && (
                        <div className="flex items-center gap-1">
                            <span className="text-gray-500">Expires:</span>
                            <span className="font-medium">
                                {moment(passportExpiryDate).format("DD MMM YYYY")}
                            </span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default PassportInfo;
